import React from 'react'
import '../i18n'

import Layout from '../components/Layout/Layout'
import KvaliHeader from '../views/Main/KvaliHeader'
import ProudOfMember from '../views/Main/ProudOfMember/ProudOfMember'
import KvaliFeatures from '../views/Main/kvaliFeatures/KvaliFeatures'
import ObjectiveDecisions from '../views/Main/ObjectiveDecisions/ObjectiveDecisions'
import CertifiedAndCompliant from '../views/Main/CertifiedAndCompliant/CertifiedAndCompliant'
import ContactUs from '../views/Main/ContactUs/ContactUs'
import DashboardView from '../views/Main/DashboardView/DashboardView'
import ApiStructure from '../views/Main/ApiStructure'
import KvaliCustomers from '../views/Main/KvaliCustomers/KvaliCustomers'
import KvaliIntegrations from '../views/Main/KvaliIntegrations/KvaliIntegrations'
import KvaliFaq from '../views/Main/KvaliFaq/KvaliFaq'
import CaseStudies from '../views/Main/CaseStudies/CaseStudies'
import leftGradient from '../resources/images/kvali-left-gradient.svg'
import rightGradient from '../resources/images/kvali-right-gradient.svg'
import dashboardBackgSvg from '../resources/images/dashboardBackground.svg'
import contactUsBg from '../resources/images/contact-us-bg.svg'
import useWindowDimension from '../hooks/useWindowDimension'
import VerificationFlow from '../views/Main/VerificationFlow/VerificationFlow'
import PluginMain from "../views/Main/PluginsMain/PluginsMain";
import GenerateLinks from "../views/Main/GeneraTeLinks/GeneraTeLinks";

export default ({ location }) => {
	const { isMobile } = useWindowDimension()
	return (
		<>
			<Layout darkColor>
				<section className='header-main light-section'>
					<KvaliHeader hideLogoList />
					<img className='image-left-container' loading='lazy' src={leftGradient} alt='' />
					<img className='image-right-container' loading='lazy' src={rightGradient} alt='' />
				</section>
				<section>
					<KvaliCustomers />
				</section>
				<section className='light-section reset-mrg'>
					<KvaliFeatures />
				</section>
				<section className='light-section reset-mrg'>
					<CaseStudies active={location.state?.active} />
				</section>
				<section className='light-section reset-mrg'>
					<ObjectiveDecisions />
				</section>
				<section className='light-section reset-mrg pos-relative testt-1'>
					<DashboardView />
					{!isMobile && <img className='background-image-dashboard' src={dashboardBackgSvg} alt='' />}
				</section>
				<section className='light-section reset-mrg'>
					<ApiStructure />
				</section>
				<section className='light-section reset-mrg'>
					<PluginMain />
				</section>
				<section className='light-section reset-mrg'>
					<GenerateLinks />
				</section>

				<section>
					<VerificationFlow />
				</section>
				<section className='light-section reset-mrg'>
					<KvaliIntegrations />
				</section>
				<section className='light-section reset-mrg'>
					<KvaliFaq />
				</section>
				<section className='dark-section-kvl  reset-mrg'>
					<CertifiedAndCompliant />
				</section>
				<section className='light-section  reset-mrg pos-relative'>
					<ContactUs />
					<img className='contact-us-image-bg' src={contactUsBg} alt='' />
				</section>
				<section className='dark-section-kvl reset-mrg'>
					<ProudOfMember />
				</section>
			</Layout>
		</>
	)
}
